export { default as af } from "./af.mjs";
export { default as ar } from "./ar.mjs";
export { default as bg } from "./bg.mjs";
export { default as ca } from "./ca.mjs";
export { default as ckb } from "./ckb.mjs";
export { default as cs } from "./cs.mjs";
export { default as da } from "./da.mjs";
export { default as de } from "./de.mjs";
export { default as el } from "./el.mjs";
export { default as en } from "./en.mjs";
export { default as es } from "./es.mjs";
export { default as et } from "./et.mjs";
export { default as fa } from "./fa.mjs";
export { default as fi } from "./fi.mjs";
export { default as fr } from "./fr.mjs";
export { default as hr } from "./hr.mjs";
export { default as hu } from "./hu.mjs";
export { default as he } from "./he.mjs";
export { default as id } from "./id.mjs";
export { default as it } from "./it.mjs";
export { default as ja } from "./ja.mjs";
export { default as ko } from "./ko.mjs";
export { default as lv } from "./lv.mjs";
export { default as lt } from "./lt.mjs";
export { default as nl } from "./nl.mjs";
export { default as no } from "./no.mjs";
export { default as pl } from "./pl.mjs";
export { default as pt } from "./pt.mjs";
export { default as ro } from "./ro.mjs";
export { default as ru } from "./ru.mjs";
export { default as sk } from "./sk.mjs";
export { default as sl } from "./sl.mjs";
export { default as srCyrl } from "./sr-Cyrl.mjs";
export { default as srLatn } from "./sr-Latn.mjs";
export { default as sv } from "./sv.mjs";
export { default as th } from "./th.mjs";
export { default as tr } from "./tr.mjs";
export { default as az } from "./az.mjs";
export { default as uk } from "./uk.mjs";
export { default as vi } from "./vi.mjs";
export { default as zhHans } from "./zh-Hans.mjs";
export { default as zhHant } from "./zh-Hant.mjs";
export const defaultRtl = {
  af: false,
  ar: true,
  bg: false,
  ca: false,
  ckb: false,
  cs: false,
  de: false,
  el: false,
  en: false,
  es: false,
  et: false,
  fa: true,
  fi: false,
  fr: false,
  hr: false,
  hu: false,
  he: true,
  id: false,
  it: false,
  ja: false,
  ko: false,
  lv: false,
  lt: false,
  nl: false,
  no: false,
  pl: false,
  pt: false,
  ro: false,
  ru: false,
  sk: false,
  sl: false,
  srCyrl: false,
  srLatn: false,
  sv: false,
  th: false,
  tr: false,
  az: false,
  uk: false,
  vi: false,
  zhHans: false,
  zhHant: false
};
//# sourceMappingURL=index.mjs.map